module.exports = __webpack_public_path__ + "img/hc3620_top_001.4eacadc9.png";